import { redirectToLogin } from "./annoucement-sheet";
import { api, language } from "./api";
import authHeader from "./auth-header";
export type Header = {
  id: number;
  title_en: string;
  title_tc: string;
  title_sc: string;
  type: string;
};
export type HeaderData={
    current_page:number,
    data:Header[],
    total:number;
}
export type PaginationData = {
  page: number;
  limit: number | string | undefined;
  search: string | number;
  sort?: string;
};
export type MenuData = {
  menu_list: Header[];
};

export const menuApi = api.injectEndpoints({
  endpoints: (build) => ({
    getMenus: build.query<HeaderData, PaginationData>({
      query: ({ limit, page, search,sort }) => ({
        url: `menus?per_page=${limit}&page=${page}&search=${search}&sort=${sort}`,
        headers: authHeader(),
      }),
      keepUnusedDataFor:0,
      transformErrorResponse: (err) => {
        if (err?.status === 401) {
          redirectToLogin();
        }
      },
      providesTags: () => [{ type: "Header" as const, id: "LIST" }],
    }),
    getMenusInfo: build.mutation<HeaderData, PaginationData>({
      query: ({ limit, page, search,sort }) => ({
        url: `menus?per_page=${limit}&page=${page}&search=${search}&sort=${sort}`,
        headers: authHeader(),
      }),
      transformErrorResponse: (err) => {
        if (err?.status === 401) {
          redirectToLogin();
        }
      },
    }),
    createManual: build.mutation<MenuData, Header>({
      query:(body)=> {
        return {
          headers: authHeader(),
          url: `menus`,
          body,
          method: "POST",
        };
      },
      invalidatesTags: () => [{ type: 'Header' }],
    }),
    updateMenu: build.mutation<Header, Header>({
      query:(body)=> {
        return {
          headers: authHeader(),
          url: `menus`,
          body,
          method: "POST",
        };
      },
      invalidatesTags: () => [{ type: 'Header' }],
    }),
    deleteMenu: build.mutation<MenuData, number>({
      query:(id)=> {
        console.log("id ",id)
        return {
          headers: authHeader(),
          url: `/menus/${id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: () => [{ type: 'Header' }],
    }),
  }),
});

export const {
  useGetMenusQuery,
  useUpdateMenuMutation,useGetMenusInfoMutation,useDeleteMenuMutation
} = menuApi;

export const {
  endpoints: { getMenus, updateMenu, getMenusInfo,deleteMenu },
} = menuApi;
